import { render } from "./noItems.vue?vue&type=template&id=4eccf9ff&scoped=true"
const script = {}

import "./noItems.vue?vue&type=style&index=0&id=4eccf9ff&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eccf9ff"]])

export default __exports__